import { Box, Stack, Typography } from "@braintrust/braintrust-ui-components";
import { WarningIcon } from "@braintrust/braintrust-ui-components/Icons";

type NonSupportedCountriesWarningPanelProps = {
  count: number;
};

export const NonSupportedCountriesWarningPanel = ({
  count,
}: NonSupportedCountriesWarningPanelProps) => {
  return (
    <Box
      sx={{
        borderRadius: "14px",
        overflow: "hidden",
        border: "1px solid #E8B500",
        background: "linear-gradient(180deg, #FFF4D0 0%, #FFE99A 100%)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: "#FDE68A",
          px: 2.25,
          py: 1.75,
          background: "#FFD93D",
          borderBottom: "1px solid #E8B50066",
        }}
      >
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            width: "28px",
            height: "28px",
            background: "var(--black)",
            borderRadius: 2,
            flexShrink: 0,
          }}
        >
          <WarningIcon
            sx={{ fontSize: 14, color: "#FFD93D", path: { strokeWidth: "3" } }}
          />
        </Box>
        <Typography
          component="p"
          variant="label"
          size="small"
          sx={{
            letterSpacing: "1.2px !important",
            fontSize: "11px !important",
          }}
        >
          IMPORTANT · ACTION REQUIRED
        </Typography>
      </Box>

      <Stack
        sx={{
          py: 2,
          px: 2.25,
          gap: 2,
        }}
      >
        <Typography component="p" variant="paragraph" size="small">
          The {count === 1 ? "location" : "locations"} highlighted{" "}
          {count === 1 ? "is" : "are"} not locations that we can support direct
          payment to talent. If the client is paying the talent directly, please
          mark this job as{" "}
          <Typography component="span" variant="label" size="small">
            &ldquo;Client will pay talent directly&rdquo;
          </Typography>{" "}
          on the job set up settings in order to proceed, or remove the
          unsupported {count === 1 ? "location" : "locations"}.
        </Typography>

        <Box
          sx={{
            borderTop: "1px solid #E8B50066",
            pt: 2,
          }}
        >
          <Typography
            component="p"
            variant="label"
            size="small"
            sx={{
              color: "#8A6E00",
              mb: 1.5,
              fontSize: "11px !important",
              letterSpacing: "1.2px !important",
            }}
          >
            TWO WAYS TO RESOLVE
          </Typography>
          <Stack sx={{ gap: 1.5 }}>
            <ResolveStep number={1}>
              Go back to{" "}
              <Typography
                component="span"
                variant="label"
                size="small"
                fontWeight={500}
              >
                Step 1
              </Typography>{" "}
              and toggle on{" "}
              <Typography
                component="span"
                variant="label"
                size="small"
                fontWeight={500}
              >
                Client will pay talent directly
              </Typography>
            </ResolveStep>
            <ResolveStep number={2}>
              Remove the non-supported {count === 1 ? "country" : "countries"}{" "}
              from project locations
            </ResolveStep>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

type ResolveStepProps = {
  number: number;
  children: React.ReactNode;
};

const ResolveStep = ({ number, children }: ResolveStepProps) => {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
      <Box
        sx={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: "var(--black)",
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          mt: "3px",
        }}
      >
        <Typography
          component="span"
          sx={{ fontSize: "11px !important", color: "#FFD93D", mt: "1px" }}
          fontWeight={500}
        >
          {number}
        </Typography>
      </Box>
      <Typography
        component="p"
        variant="paragraph"
        size="small"
        sx={{ mt: "2px" }}
      >
        {children}
      </Typography>
    </Box>
  );
};
